// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-50[data-v-1e990862]{margin-top:200px}.initiatives-article-footer[data-v-1e990862]{background-color:#131313;color:#4e4e4e;max-height:320px;padding:98px 30px}.initiatives-article-footer hr[data-v-1e990862]{width:50px;border-color:#ffc9c4}.initiatives-article-footer .link[data-v-1e990862]{color:#ffc9c4}.initiatives-article-footer h3[data-v-1e990862]{font-size:5.5vh}", ""]);
// Exports
module.exports = exports;
